import * as Yup from "yup";
import {
  maxDateToDayField,
  requiredField,
} from "../../../../shared/helpers/getMessageValidation";
import {
  addresSchema,
  contactSchema,
  personSchema,
} from "../firstStep/validationSchema";

export const academicEducationsSchema = Yup.object({
  degree: Yup.string().required(requiredField()),
  startDate: Yup.date().max(new Date(Date.now()), maxDateToDayField()).nullable(),
  endDate: Yup.date().max(new Date(Date.now()), maxDateToDayField()).nullable(),
});

export const languages = Yup.object({
  language: Yup.string().required(requiredField()).typeError(requiredField()),
});

export const techResource = Yup.object({
  remoteWork: Yup.string().required(requiredField()).typeError(requiredField()),
  ownComputer: Yup.string()
    .required(requiredField())
    .typeError(requiredField()),
  internet: Yup.string().required(requiredField()).typeError(requiredField()),
});

export const getSchemaValidationSecondStep = () => {
  const secondStepValidation = Yup.object({
    person: personSchema,
    address: addresSchema,
    contactInformation: contactSchema,
    academicEducations: Yup.array().of(academicEducationsSchema),
    languages: Yup.array().of(languages),
    techResource,
  });
  return secondStepValidation;
};
